import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2';

function PaoFormatter(anio, termino1, termino2, termino3) {
    if (termino1 === "1") {
        return <>PAO {anio}-1</>

    } else if (termino2 === "2") {
        return <>PAO {anio}-2</>

    } else if (termino3 === "0") {
        return <>PAE {anio}</>
    }
}

export class Solicitud_actividad extends Component {
    static displayName = Solicitud_actividad.name;

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino: "", termino1: false, termino2: false, termino3: false, periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            }, termino: "",periodos:"", observacion: "", pao1: "", pao2: "", pae: "", accion: "",loading: false, loading2: false, idUnico: this.props.idUnico ?? ""
        };
        this.onInputChange = this.onInputChange.bind(this);  
        this.agregarSolicitud = this.agregarSolicitud.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onChangePao = this.onChangePao.bind(this);
        this.onChangeRadioAcciones = this.onChangeRadioAcciones.bind(this);
    }

    componentDidMount() {
        var termino1 = this.props.termino1 === "1" ? true : false;
        var termino2 = this.props.termino2 === "2" ? true : false;
        var termino3 = this.props.termino3 === "0" ? true : false;
        this.setState({
            //termino: this.get_radios(this.props.pao1, this.props.pao2, this.props.pae, this.props.anio),
            observacion: this.props.observacion, termino1: termino1, termino2: termino2, termino3: termino3
        }); 
        //console.log(this.state.termino)
    }

    //funcion para click en update delete
    handleClick = (text) => {
        //console.log('handleClick: ', text);
        this.setState({
            accion: text,
        });
    }
    onChangeValue(event) {
        //console.log("onChangeValue: ", event.target.value);
        var textAc = "";
        if (event.target.value === 0) {
            textAc = "Modificar Carga";
        } else if (event.target.value === 1) {
            textAc = "Eliminar Carga";
        }
        this.setState({
            //accion: event.target.value,
            accion: textAc,
        });
    }

    // funcion para los radio buttons de update delete
    onChangeRadioAcciones(text) {
        //console.log("onChangeRadioAcciones: ", text);
        this.setState({
            accion: text,
        });
    }

    onChangePao(event) {
        //console.log('CLICK EN->' + event.target.value)
        //console.log('ESTADO DE Checked->' + event.target.checked)
        if (event.target.value == 1) {
            this.setState({
                termino1: event.target.checked ? true : false
            })
        }

        if (event.target.value == 2) {
            this.setState({
                termino2: event.target.checked ? true : false
            })
        }

        if (event.target.value == 0) {
            this.setState({
                termino3: event.target.checked ? true : false
            })
        }
         
    }
        onInputChange(event) {
            //console.log(JSON.stringify(event.target.name))
            var control = event.target.name;
            if (control === "review") {
                //var value = this.state.observacion;
                var value = event.target.value.toUpperCase();
                this.setState({
                    observacion: value
                });
            }
            else if (control === "inlineRadioOptions") {
                var value = event.target.value;

                this.setState({
                    pao1: value == 1 ? "1" : "",
                    pao2: value == 2 ? "2" : "",
                    pa3: value == 3 ? "3" : ""
                });
            } else if (control === "inlineRadioAction") {
                var value = event.target.value;
                this.setState({
                    accion: value,
                });
            }
        }
     
    agregarSolicitud(event) { 
        event.preventDefault();
        
        if ((this.state.observacion !== "" && this.state.observacion !== undefined && this.state.observacion !== null) && this.state.accion !== "" && (this.state.termino1 || this.state.termino2 || this.state.termino3)) {
            let d1 = this.state.termino1 ? 'PAO ' + this.props.anio + '-1' : ''
            let d2 = this.state.termino2 ? 'PAO ' + this.props.anio + '-2' : '' 
            let d3 = this.state.termino3 ? 'PAE ' + this.props.anio : '';
            let terminoeval = d3 + ' ' + d1 + ' ' + d2

            Swal.fire({
                title: 'Hecho!',
                text: 'Actividad agregada exitosamente',
                icon: 'success',
                timer: 1500,
                confirmButtonText: 'Ok'

            })
            this.setState({ termino1: false, termino2: false, termino3: false });
            //console.log('AGREEGANDO SOLICITUD[EXPAND]: ' + this.props.idactividad + '|' + this.props.descripcion + '|' + this.props.totalhoras + '|' + this.props.anio + '|' + terminoeval+'|'+ this.props.tipoactividad+'|'+ this.state.observacion+'|'+ this.props.termino1+'|'+ this.props.termino2+'|'+ this.props.termino3+'|'+ this.state.accion)
            this.props.updatestate(this.props.rowIndex, this.props.idactividad, this.props.descripcion, this.props.totalhoras, this.props.anio, terminoeval, this.props.tipoactividad, this.state.observacion, this.props.termino1, this.props.termino2, this.props.termino3, this.state.accion, this.props.idUnico)
            this.props.closeExpandxId(this.props.idUnico)


        } else {

            Swal.fire({
                title: 'ERROR!',
                text: 'Debes llenar los campos observación, periodo y escoger acción',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            })
        }
    }
    handlkeyPress(evento) {
        // console.log(String.fromCharCode(event.keyCode));
        let tecla = evento.which;
        let caracter = String.fromCharCode(tecla)
        let regex = new RegExp("^[A-Za-z0-9 ,.]+$");


        if (!regex.test(caracter)) {

            Swal.fire({
                title: 'Lo sentimos!',
                text: 'El campo de observación no permite caracteres especiales.',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            })
            
            return false;
        }

    }
    render() {
        var terminoText = PaoFormatter(this.props.anio, this.props.termino1, this.props.termino2, this.props.termino3);
        
       // console.log(this.props)
        return (
            <div>
                <div className="box2 sb9"><table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr className='tr-tablexpand-header'>
                            <th className='tr-descr-header'></th>
                            <th className='tr-obser-header'></th>
                            <th className='tr-perio-header'></th>
                            <th className='tr-accio-header'></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className='td-descr-header'>Actividad</td>
                            <td className='td-obser-header'>Observación <label className="asterisco">*</label></td>
                            <td className='td-perio-header'>Periodo <label className="asterisco">*</label></td>
                            <td className='td-accio-header'>Acciones <label className="asterisco">*</label></td>
                        </tr>
                        <tr>
                            <td>{this.props.descripcion}</td>
                            <td><textarea id="review" name="review" onKeyPress={this.handlkeyPress} className='area_width' value={this.state.observacion} onChange={this.onInputChange}>{this.state.observacion}</textarea></td>
                            <td>
                                {terminoText}
                                {/*<div>*/}
                                {/*    <div onChange={this.onChangePao}>*/}
                                {/*        <input type="checkbox" className="form-radio" name="radio" value="1" />PAO {this.props.anio}-1 <br />*/}
                                {/*        <input type="checkbox" className="form-radio" name="radio" value="2" />PAO {this.props.anio}-2 <br />*/}
                                {/*        <input type="checkbox" className="form-radio paatras" name="radio" value="0" />PAE {this.props.anio}*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </td>
                            <td>
                                <div> {/*onChange={this.onChangeValue}*/}
                                    <ul id="list" className="list-group pb-4 text-align-center center-radio-div">
                                        <li className="list-group-item d-flex justify-content-between align-items-center"> {/*onClick={() => this.handleClick("Modificar Carga")}*/}
                                            <input className="form-check-input" type="radio" name="radiosAccion" id="radioModificar" value="0" onChange={() => { this.onChangeRadioAcciones("Modificar Carga") }} />Modificar
                                            {/*<label className="form-check-label" htmlFor="radioModificar">Modificar</label>*/}

                                            {/*<FontAwesomeIcon icon={faEdit} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Modificar Carga")} title="Modificar Carga" style={this.state.accion === "Modificar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />Modificar*/}
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center"> {/*onClick={() => this.handleClick("Eliminar Carga")}*/}
                                            <input className="form-check-input" type="radio" name="radiosAccion" id="radioEliminar" value="1" onChange={() => { this.onChangeRadioAcciones("Eliminar Carga") }} />Eliminar
                                            {/*<label className="form-check-label" htmlFor="radioEliminar">Eliminar</label>*/}

                                            {/*<FontAwesomeIcon icon={faTrash} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Eliminar Carga")} title="Eliminar Carga" style={this.state.accion === "Eliminar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />Eliminar*/}
                                        </li>
                                    </ul>
                                </div>


                                <div>
                                    <button type="button" className="btn btn-sm btn-info btn-agregar" onClick={this.agregarSolicitud}>    {/* funcion para guardar la solicitud y enviar a la unificada*/}
                                        <img width="24px" height="24px" src={enviar} />Agregar Observación</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>





                </div>

            </div>
        );
    }


}
